import type { FaireThemeEntity } from "../../entity_types/theme";

export const rustic_depot_farmhouse_charm_wall_kitchen_porch: FaireThemeEntity =
  {
    token: "rustic-depot-farmhouse-charm-wall-kitchen-porch",
    type: "theme",
    retailerToken: "r_464eox2tas",
    name: "Farmhouse Charm",
    description: "Rustic signs, kitchen accents, and porch pieces",
    bgColor: "#F5E6C8",
    tileBgColor: "#85552d",
    productTokens: [
      "p_rxt2bzr743",
      "p_yc6nyrnx9e",
      "p_y58mgwambh",
      "p_tg4v4apew5",
      "p_mu9683qywm",
      "p_85x7wws9sy",
      "p_uew9399zpe",
      "p_8gx8acag4q",
      "p_ce7gutr286",
      "p_a8sh7xvegq",
      "p_389c2pc6rk",
      "p_6czzft5fyf",
      "p_my63jptwvq",
      "p_u47pbbc6v7",
      "p_ryyxrezupc",
      "p_ft4nxutj5a",
      "p_4rbhx4qsg5",
      "p_qy2pmxqf52",
      "p_shwsgju9xk",
      "p_pztgvavf48",
    ],
    exactProducts: true,
    meta: {
      source: "mock",
      importedAt: "2026-03-24T13:50:10Z",
      importedBy: "retailer-themes-entity-migration",
    },
  };
